// react
import React from 'react'

import { useRetractSidebar } from '_hooks'

// components
import EntityEditForm from '_components/entity-edit-form/index.jsx'

const DataSourcePage = (props) => {
  useRetractSidebar()

  return (
    <div id="data-source-page">
      <EntityEditForm
        entities="data-sources"
        id={props.match.params.id}
        fields={[
          { name: 'name', disabled: true },
          { name: 'description' },
          { name: 'type' },
          { name: 'log_file' },
          { name: 'cors' },
          { name: 'redirect_param' },
        ]}
        resource="Data Sources"
      />
    </div>
  )
}

export default DataSourcePage
